import { render, staticRenderFns } from "./Leaf.vue?vue&type=template&id=2c0ac1b2&scoped=true&"
import script from "./Leaf.vue?vue&type=script&lang=js&"
export * from "./Leaf.vue?vue&type=script&lang=js&"
import style0 from "./Leaf.vue?vue&type=style&index=0&id=2c0ac1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ac1b2",
  null
  
)

export default component.exports